"use client";
import { Card, CardContent, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Box from "@mui/material/Box";

import CardMedia from "@mui/material/CardMedia";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";

import NextLink from "next/link";
import { Container } from "@mui/material";
import Image from "next/image";
import Link from "@mui/material/Link";

const SyledCard = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: 0,
  height: "100%",
  border: "2px solid",
  borderColor: theme.palette.divider,
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    cursor: "pointer",
    transform: "translateY(-4px)",
    // boxShadow: `0 4px 20px ${
    //   theme.palette.mode === "light" ? "rgba(0,0,0,0.05)" : "rgba(0,0,0,0.3)"
    // }`,
  },
}));

const SyledCardContent = styled(CardContent)({
  display: "flex",
  flexDirection: "column",
  gap: 4,

  flexGrow: 1,
  // "&:last-child": {
  //   paddingBottom: 16,
  // },
});

const StyledTypography = styled(Typography)({
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2,
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const cardData = [
  {
    slug: "2025/naive-global-illumination-using-p5.js",

    img: "/images/articles/2025/naive-global-illumination-using-p5.js/naive-two-dimensional-global-illumination-using-p5.js-thumbnail.png",
    title: "Naive Two-Dimensional Global Illumination Using p5.js",
    description:
      "Achieving photorealistic results has long been an area of interest in computer graphics. Recent developments in consumer-grade ray-tracing hardware has allowed for increasingly realistic appearing results in real time applications such as video games.",
  },
];

export default function BlogExplorer() {
  const [filter, setFilter] = React.useState("All");
  const [searchTerm, setSearchTerm] = React.useState("");

  const handleClick = (category: string) => {
    setFilter(category);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const filteredData = cardData.filter((card) => {
    const matchesCategory = filter === "All" || card.tag === filter;
    const matchesSearch =
      card.title.toLowerCase().includes(searchTerm) ||
      card.description.toLowerCase().includes(searchTerm);
    return matchesCategory && matchesSearch;
  });

  const categories = [
    "All",
    ...Array.from(new Set(cardData.map((c) => c.tag))),
  ];

  return (
    <Container>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            flexDirection: "row",
            gap: 1,
            overflow: "auto",
            p: 1,
          }}
        >
          {categories.map((category) => (
            <Chip
              key={category}
              onClick={() => handleClick(category)}
              size="medium"
              label={category}
              variant={filter === category ? "filled" : "outlined"}
              color={filter === category ? "primary" : "default"}
            />
          ))}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            alignItems: "center",
          }}
        >
          <FormControl
            sx={{ width: { xs: "100%", md: "25ch" } }}
            variant="outlined"
          >
            <OutlinedInput
              size="small"
              id="search"
              placeholder="Search articles…"
              onChange={handleSearchChange}
              startAdornment={
                <InputAdornment position="start">
                  <SearchRoundedIcon fontSize="small" />
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
      </Box> */}
        <Typography sx={{ textAlign: "center", mb: 0 }} variant="h1">
          Articles
        </Typography>
        <Grid container spacing={2} justifyContent="center">
          {filteredData.map((card, index) => (
            <Grid size={{ xs: 12, md: 10, lg: 8 }} key={index}>
              <Link
                component={NextLink}
                href={`/articles/${card.slug}`}
                passHref
                style={{ textDecoration: "none" }}
              >
                <SyledCard
                  variant="outlined"
                  sx={{ borderRadius: 0, alignItems: "center", p: 2 }}
                >
                  <Box
                    sx={{
                      position: "relative", // Required for the Image's 'fill' prop
                      width: "60%", // Make the container responsive
                      aspectRatio: "1 / 1", // This enforces the square aspect ratio
                    }}
                  >
                    <Image
                      priority={true}
                      quality={75}
                      alt={card.title}
                      src={card.img}
                      sizes="60vw"
                      fill // This makes the image fill the parent Box
                      style={{
                        objectFit: "cover", // Ensures the image covers the area without distortion
                      }}
                    />
                  </Box>
                  <SyledCardContent sx={{}}>
                    <Typography variant="h5" component="div" fontWeight="bold">
                      {card.title}
                    </Typography>
                    <StyledTypography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 0 }}
                    >
                      {card.description}
                    </StyledTypography>
                  </SyledCardContent>
                </SyledCard>
              </Link>
            </Grid>
          ))}
          {filteredData.length === 0 && (
            <Grid item xs={12} sx={{ textAlign: "center", py: 8 }}>
              <Typography variant="h6">No articles found.</Typography>
              <Typography color="text.secondary">
                Try adjusting your search or filter.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </Container>
  );
}
